'use strict';

export default {
    collapsed: false
};
